var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualizationCapacitySvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.383,
    height: 46.383,
    viewBox: "0 0 37.383 46.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y2: 0.876,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fb2ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e64ed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.363,9.492H20.757V.886A.886.886,0,0,0,19.871,0H10.378a.886.886,0,0,0-.886.886V9.492H.886A.886.886,0,0,0,0,10.378v9.492a.886.886,0,0,0,.886.886H9.492v8.606a.886.886,0,0,0,.886.886h9.492a.886.886,0,0,0,.886-.886V20.757h8.606a.886.886,0,0,0,.886-.886V10.378A.886.886,0,0,0,29.363,9.492Zm-.886,9.492H19.871a.886.886,0,0,0-.886.886v8.606h-7.72V19.871a.886.886,0,0,0-.886-.886H1.772v-7.72h8.606a.886.886,0,0,0,.886-.886V1.772h7.72v8.606a.886.886,0,0,0,.886.886h8.606Z",
    transform: "translate(0 16.134)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.786,6.4h-5.8V.6a.6.6,0,0,0-.6-.6h-6.4a.6.6,0,0,0-.6.6V6.4H.6a.6.6,0,0,0-.6.6v6.4a.6.6,0,0,0,.6.6H6.4v5.8a.6.6,0,0,0,.6.6h6.4a.6.6,0,0,0,.6-.6v-5.8h5.8a.6.6,0,0,0,.6-.6v-6.4A.6.6,0,0,0,19.786,6.4Zm-.6,6.4h-5.8a.6.6,0,0,0-.6.6v5.8h-5.2v-5.8a.6.6,0,0,0-.6-.6h-5.8v-5.2h5.8a.6.6,0,0,0,.6-.6v-5.8h5.2v5.8a.6.6,0,0,0,.6.6h5.8Z",
    transform: "translate(17)",
    opacity: 0.3,
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizationCapacitySvg);
export default __webpack_public_path__ + "static/media/VisualizationCapacitySVG.ecd72a46.svg";
export { ForwardRef as ReactComponent };